module.exports = __webpack_public_path__ + "media/images/users-9e66f647.png";